import { PopoverContentProps } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { FileItem } from "src/components/Inputs/FileItem";
import { getPreviewUrl, type Logo } from "./schema";

type Props = {
  logo: Logo;
  onDelete: () => void;
  previewPopoverProps?: PopoverContentProps;
};
export const LogoPreview: FunctionComponent<Props> = ({
  logo,
  onDelete,
  previewPopoverProps,
}) => {
  if (logo.type === "default") {
    // This is a default logo, don't show anything
    return null;
  }

  return (
    <FileItem
      name={logo.name}
      onDelete={onDelete}
      previewUrl={getPreviewUrl(logo)}
      previewPopoverProps={previewPopoverProps}
    />
  );
};
